<template>
    <div class="rounded-xl">
        <v-dialog v-model="dialogAdd" v-if="dialogAdd" width="80%">
            <v-card class="rounded-xl">
                <v-container>
                    <order-attention-purchase v-if="orderLocal.TypeOrder == 1" @selected="selectedAttention($event)"
                        :model="true"></order-attention-purchase>
                    <order-attention-service v-if="orderLocal.TypeOrder == 3" @selected="selectedAttention($event)"
                        :model="true"></order-attention-service>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="previewDialog" max-width="900px">
            <v-card class="rounded-xl">
                <v-toolbar dense>
                    <v-toolbar-title>Vista Previa</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closePreview">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pa-0">
                    <!-- Imágenes -->
                    <v-img v-if="previewType === 'image'" :src="previewUrl" max-height="600" contain></v-img>

                    <!-- PDFs -->
                    <iframe v-else-if="previewType === 'pdf'" :src="previewUrl" width="100%" height="600px"
                        frameborder="0"></iframe>

                    <!-- Excel -->
                    <div v-else-if="previewType === 'excel'" class="excel-preview">
                        <v-tabs v-if="excelSheets.length > 1" v-model="currentSheet" background-color="primary" dark>
                            <v-tab v-for="(sheet, index) in excelSheets" :key="index">
                                {{ sheet }}
                            </v-tab>
                        </v-tabs>

                        <div style="overflow: auto; max-height: 550px; background: white;">
                            <table class="excel-table" v-if="excelData.length > 0">
                                <tbody>
                                    <tr v-for="(row, rowIndex) in excelData" :key="rowIndex">
                                        <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                                            {{ cell }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-else class="pa-4 text-center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                <p class="mt-2">Cargando Excel...</p>
                            </div>
                        </div>
                    </div>

                    <!-- Word -->
                    <div v-else-if="previewType === 'word'" class="word-preview">
                        <div v-if="wordContent" class="word-content pa-6" v-html="wordContent"></div>
                        <div v-else class="pa-4 text-center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            <p class="mt-2">Cargando documento Word...</p>
                        </div>
                    </div>

                    <!-- Otros tipos -->
                    <div v-else class="pa-4 text-center">
                        <v-icon size="100" color="grey">mdi-file</v-icon>
                        <p class="mt-4">No se puede previsualizar este tipo de archivo</p>
                        <v-btn color="primary" @click="downloadFile(currentFile)">
                            Descargar para ver
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <s-processing v-model="processing" :message="message"></s-processing>

        <!--CIRCUITO DE APRBACIONES MODAL-->
        <div v-if="dialogCircuit">
            <v-dialog v-model="dialogCircuit" width="80%" persistent>
                <s-toolbar color="primary" dark label="Circuitos Asociados a la Operación"
                    @close="dialogCircuit = false"></s-toolbar>
                <v-card>
                    <v-container>
                        <v-row>
                            <v-col lg="7">
                                <v-text-field v-model="searchCircuit" append-icon="mdi-magnify"
                                    label="Buscar circuito..." single-line hide-details class="mb-3"></v-text-field>
                                <v-data-table dense item-key="AccID" :items="circuits" :items-per-page="-1" :headers="[
                                    { value: 'AccID', text: 'ID' },
                                    { value: 'AccName', text: 'Circuito' },
                                ]" :search="searchCircuit" @dblclick:row="createCircuit" v-model="selectedCircuit"
                                    @click:row="rowClickCircuit" />
                            </v-col>
                            <v-col lg="5">
                                <s-crud v-if="this.filterLevels.AccID != null" no-toolbar :config="configLevels"
                                    :filter="filterLevels" title="Niveles" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
        </div>

        <v-card class="rounded-xl">
            <s-toolbar :download="orderLocal.OrdStatus == 5" @download="downloadPdf()"
                :add="!value || OrdStatusValue == 7 || this.orderLocal.IsEditOrder == 1" @add="dialogAdd = true"
                :load="orderLocal.OrdStatus == 1 && viewLoad && UseServiceLayer == 0" close
                :save="value == null || orderLocal.OrdStatus == 3 || (orderLocal.IsEditOrder == 1 && isEditableOC)"
                @save="save()" :label="this.value
                    ? (orderLocal.OrdDocumentNumber ? orderLocal.OrdDocumentNumber : '') + ' - ' + (orderLocal.NtpFullName ? orderLocal.NtpFullName : '')
                    : 'Orden de Compra'
                    " @close="$emit('onClose')" :transactionApproved="transactionApproved" @load="loadExternal()"
                :beforeApprove="true" @before-approve="updateOddAccount" class="rounded-xl">
                <template v-slot:options>
                    <v-tooltip bottom=""
                        v-if="$fun.hasSpecialPermission('Demo') || (orderLocal.OrdStatus == 1 && viewLoad && UseServiceLayer == 1)">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" text black @click="saveDemo()" small>
                                <v-icon>mdi-cloud-upload</v-icon>
                            </v-btn>
                        </template>
                        <span>Subir con Service Layer</span>
                    </v-tooltip>
                </template>
            </s-toolbar>

            <v-card :loading="loadingCard">
                <v-col>
                    <v-row>
                        <v-col lg="12">
                            <v-row>
                                <v-col style="">
                                    <v-row>
                                        <v-col class="s-col-text">
                                            <s-text v-if="orderLocal.OrdStatus == 5 || (order && order.SupID)" disabled
                                                label="Proveedor" v-model="orderLocal.SupName" />
                                            <s-supplier v-else :readonly="!isEditable" label="Proveedor"
                                                v-model="Supplier" />
                                        </v-col>
                                        <v-col lg="3" cols="12" class="s-col-text">
                                            <s-contact-supplier :disabled="!isEditable" label="Contacto" :SupID="SupID"
                                                v-model="orderLocal.ConID" />
                                        </v-col>
                                        <v-col lg="2" cols="6" class="s-col-text">
                                            <s-select-definition :disabled="!isEditable" :def="1129" label="Moneda"
                                                v-model="orderLocal.TypeCurrency" />
                                        </v-col>
                                        <v-col lg="2" class="s-col-text">
                                            <s-date label="Fecha" v-model="dateOrder" :disabled="!isEditable"></s-date>
                                        </v-col>
                                        <v-col lg="2" class="s-col-text"
                                            v-if="(value && OrdStatusValue == 7) || isStatusActive">
                                            <s-select-definition :dgr="96" :def="1151" label="Estado"
                                                v-model="orderLocal.OrdStatus" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col lg="9" style="padding-right: 0px" cols="12">

                            <v-row>
                                <v-col>
                                    <div class="mt-2">
                                        <s-toolbar label="Detalle" :add="isEditable" @add="dialogAdd = true"
                                            :remove="isEditable" @removed="removeItem()"
                                            v-if="orderLocal.OrdStatus == 3"></s-toolbar>
                                    </div>
                                    <v-data-table dense @click:row="rowClick" :headers="headersSAP" :items-per-page="-1"
                                        v-model="selectedSAP" :items="itemsSAP" item-key="Line" :loading="loading"
                                        :height="$vuetify.breakpoint.xs ? 'auto' : '300'" hide-default-footer>
                                        <!-- Duplicar fila  v-if="orderLocal.TypeOrder != 1"-->
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.OddDescriptionNew="{ item }">
                                            <div class="d-flex align-center">
                                                <v-chip v-if="item.ItemGroupName == 'Activos Fijos'" :color="'#18FFFF'"
                                                    small>
                                                    {{ item.ItemGroupName }}
                                                </v-chip>

                                                {{ item.OddDescription }}
                                            </div>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.action='{ item }'>
                                            <!-- <template  v-slot:[`item.action`]="{ item }"> -->
                                            <!-- <v-btn @click="addItem(item)" 
                       v-if="isEditable"  
                       :hidden="!isEditable"
                       x-small class="v-btn v-btn--text theme--light elevation-0 v-size--small">
                        <v-icon v-if="item.duplicateLine" small class="v-icon notranslate mdi mdi-minus-circle-outline theme--light"></v-icon>
                        <v-icon v-else small class="v-icon notranslate mdi mdi-plus-circle-outline theme--light"></v-icon>
                      </v-btn> -->
                                            <v-menu v-if="isEditable" :hidden="!isEditable">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn :color="item.duplicateLine ? 'warning' : ''" icon small
                                                        v-on="on">
                                                        <v-icon>mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>
                                                <!-- v-for="(item, i) in items" -->
                                                <v-list>
                                                    <v-list-item key="ocDuplicar" @click="addItem(item)"
                                                        v-if="orderLocal.TypeOrder != 1 && !item.duplicateLine">
                                                        <v-list-item-title> Duplicar </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item key="ocdeleteLinea" @click="deleteitem(item)">
                                                        <v-list-item-title> Eliminar Linea </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.TypeCostName="props">
                                            <!-- <template  v-slot:[`item.TypeCostName`]="{ props }"> -->
                                            <div>
                                                <v-edit-dialog v-if="isEditable" large
                                                    @click="selectedSAP = [props.item]" cancel-text="Cancelar"
                                                    save-text="Guardar" @save="changeItem(props.item)">
                                                    <v-row @click="selectedSAP = [props.item]">
                                                        <v-col>
                                                            <div>{{ props.item.TypeCostName }}</div>
                                                        </v-col>
                                                    </v-row>
                                                    <template v-slot:input>
                                                        <div class="mt-4 title mb-4">Tipo de Costo</div>
                                                        <s-select-definition :def="1045" return-object
                                                            v-model="props.item.TypeCostObject" />
                                                    </template>
                                                </v-edit-dialog>
                                                <div v-else>
                                                    <div>{{ props.item.TypeCostName }}</div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.BslName="props">
                                            <!-- <template  v-slot:[`item.BslName`]="{ props }"> -->
                                            <div>
                                                <v-edit-dialog v-if="isEditable" large
                                                    @click="selectedSAP = [props.item]" cancel-text="Cancelar"
                                                    save-text="Guardar" @save="changeItem(props.item)">
                                                    <v-row @click="selectedSAP = [props.item]">
                                                        <v-col>
                                                            <div>{{ props.item.BslName }}</div>
                                                        </v-col>
                                                    </v-row>
                                                    <template v-slot:input>
                                                        <div class="mt-4 title mb-4">Linea de Negocio</div>
                                                        <!--props.item.CceID-->
                                                        <s-select-business-line
                                                            :cceID='props.item.CceID == null ? 0 : props.item.CceID'
                                                            return-object v-model="props.item.BslObject" />
                                                    </template>
                                                </v-edit-dialog>
                                                <div v-else>
                                                    <div>{{ props.item.BslName }}</div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.CceName="props">
                                            <!-- <template  v-slot:[`item.CceName`]="{ props }"> -->
                                            <div>
                                                <v-edit-dialog v-if="isEditable" large
                                                    @click="selectedSAP = [props.item]" cancel-text="Cancelar"
                                                    save-text="Guardar" @save="changeItem(props.item)">
                                                    <v-row @click="selectedSAP = [props.item]">
                                                        <v-col>
                                                            <div>{{ props.item.CceName }}</div>
                                                        </v-col>
                                                    </v-row>
                                                    <template v-slot:input>
                                                        <div class="mt-4 title mb-4">Centro de Costo</div>
                                                        <s-select-area centercost return-object
                                                            v-model="props.item.CceObject" />
                                                    </template>
                                                </v-edit-dialog>
                                                <div v-else>
                                                    <div>{{ props.item.CceName }}</div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.TaxCode="props">
                                            <!-- <template  v-slot:[`item.TaxCode`]="{ props }"> -->

                                            <div>
                                                <v-edit-dialog v-if="isEditable" large @cancel="dialogTax = false"
                                                    @close="dialogTax = false" @open="dialogTax = true"
                                                    @click="selectedSAP = [props.item]" cancel-text="Cancelar"
                                                    save-text="Guardar" @save="
                                                        dialogTax = false;
                                                    changeTax(props.item);
                                                    ">
                                                    <v-row @click="selectedSAP = [props.item]">
                                                        <v-col>
                                                            <div>{{ props.item.TaxCode }}</div>
                                                        </v-col>
                                                    </v-row>
                                                    <template v-slot:input v-if="dialogTax">
                                                        <div class="mt-4 title mb-4">
                                                            Selecciona Impuesto
                                                        </div>
                                                        <s-select-definition id="DedAbbreviation" return-object
                                                            :def="1143" v-model="tax" />
                                                    </template>
                                                </v-edit-dialog>
                                                <div v-else>
                                                    <div>{{ props.item.TaxCode }}</div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.OddUnitPrice="props">
                                            <!-- <template  v-slot:[`item.OddUnitPrice`]="{ props }"> -->
                                            <s-text style="width: 75px" decimal :maxDecimal="6"
                                                @input="changeItem(props.item)" :disabled="!isEditable"
                                                @paste="pastePrice($event)" v-model="props.item.OddUnitPrice">
                                                Precio Unitario
                                            </s-text>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <!-- <template v-slot:item.OddDaysDelivery="props">
                      <s-text style="width: 80px" decimal :disabled="!isEditable" v-model="props.item.OddDaysDelivery">
                      </s-text>
                    </template> -->

                                        <!-- modificando de descripcion si es en requerimiento de servicio -->
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.OddDescription="props" v-if="orderLocal.TypeOrder != 1">
                                            <!-- <template  v-slot:[`item.OddDescription`]="{ props }" v-if="orderLocal.TypeOrder != 1"> -->
                                            <s-text style="width: 400px" @input="changeItem(props.item)"
                                                :disabled="!isEditable" :maxlength="100"
                                                v-model="props.item.OddDescription">
                                                Descripcion</s-text>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.OddQuantity="props">
                                            <!-- <template  v-slot:[`item.OddQuantity`]="{ props }"> -->
                                            <s-text style="width: 80px" @blur="blurQuantity($event, props.item)"
                                                :disabled="!isEditable" decimal @paste="pasteQuantity($event)"
                                                v-model="props.item.OddQuantity">
                                                Cantidad Atendida
                                            </s-text>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.AcoName="props">
                                            <!-- <template  v-slot:[`item.AcoName`]="{ props }"> -->
                                            <v-edit-dialog large
                                                v-if="isTransport || (isEditable || $fun.hasSpecialPermission('EditAccount')) && $route.path.includes('configuracion/aprobacionordenes')"
                                                @save="saveAccount(props.item)" cancel-text="Cancelar"
                                                save-text="Guardar">
                                                <div>{{ props.item.AcoName }}</div>
                                                <template v-slot:input>
                                                    <div class="mt-4 mb-4">
                                                        Concepto - Cuenta Contable
                                                    </div>
                                                    <s-select item-value="ConName" clearable item-text="ConName"
                                                        label="Concepto Servicio" v-model="ConName"
                                                        :items="itemsConcept" />
                                                    <s-select label="Cuenta Contable" clearable item-value="CsaID"
                                                        return-object item-text="CsaDescription" v-model="AcoID"
                                                        :items="itemsAccount" />
                                                </template>
                                            </v-edit-dialog>
                                            <div v-else>
                                                <div>{{ props.item.AcoName }}</div>
                                            </div>
                                        </template>
                                        <!-- eslint-disable-next-line vue/valid-v-slot -->
                                        <template v-slot:item.OddObservation="props">
                                            <!-- <template  v-slot:[`item.OddObservation`]="{ props }"> -->
                                            <s-text label="" v-if="props.item.ReqID == null"
                                                v-model="props.item.OddObservation"></s-text>
                                            <div v-else>
                                                <s-text label="" v-model="props.item.OddObservation"></s-text>

                                            </div>
                                        </template>

                                        <template v-slot:item.OddDiscountPercentage="props">
                                            <s-text label="" v-model="props.item.OddDiscountPercentage"
                                                @input="changeItemPrc(props.item)" decimal :disabled="!isEditable"
                                                :maxDecimal="3"></s-text>
                                        </template>

                                        <template v-slot:item.OddDiscount="props">
                                            <span>{{ props.item.OddDiscount | numberDefault }}</span>
                                        </template>

                                        <template v-slot:item.OddTaxAmount="props">
                                            <span>{{ props.item.OddTaxAmount | numberDefault }}</span>
                                        </template>

                                        <template v-slot:item.OddAmount="props">
                                            <s-text v-if="isEditable" label="" v-model="props.item.OddAmount"
                                                @input="changeSubTotal(props.item, $event)" decimal></s-text>
                                            <span v-else>{{ props.item.OddAmount | numberDefault }}</span>
                                        </template>

                                    </v-data-table>
                                </v-col>
                            </v-row>
                            <v-col style="padding-top: 24px">
                                <v-row>
                                    <v-col lg="3" cols="12">
                                        <v-row>
                                            <v-col class="s-col-form">
                                                <s-select-definition :def="1145" label="Encargado de Compras"
                                                    :disabled="!isEditable" v-model="orderLocal.OfficePurchase" />
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <s-select-paymentterms v-model="PytID" label="Condición de Pago" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col lg="4">
                                        <v-card flat class="pa-2" outlined>
                                            <!-- SUB-TOTAL -->
                                            <v-row dense align="center" no-gutters class="py-1">
                                                <v-col cols="6">
                                                    <span class="text-body-2">SUB-TOTAL</span>
                                                </v-col>
                                                <v-col cols="6" class="text-right">
                                                    <span class="font-weight-bold">
                                                        {{ orderLocal.OrdSubTotal | numberDefault }}
                                                    </span>
                                                </v-col>
                                            </v-row>

                                            <v-divider></v-divider>
                                            
                                            <!-- DESCUENTO -->
                                            <v-row dense align="center" no-gutters class="py-1">
                                                <v-col cols="3" class="d-flex align-center">
                                                    <span class="text-body-2">DESCUENTO</span>
                                                </v-col>
                                                <v-col cols="4" class="px-1">
                                                    <s-text v-model="orderLocal.OrdDiscountPercentage"
                                                        @input="calculateTotals()" decimal :disabled="!isEditable" dense
                                                        outlined hide-details :maxDecimal="3" suffix="%"></s-text>
                                                </v-col>
                                                <v-col cols="5" class="pl-1">
                                                    <s-text v-model="orderLocal.OrdDiscountAmount"
                                                        @input="calculatePercent()" decimal :disabled="!isEditable"
                                                        dense outlined hide-details suffix="$"></s-text>
                                                </v-col>
                                            </v-row>

                                            <v-divider></v-divider>
                                            
                                            <v-row dense align="center" no-gutters class="py-1">
                                                <v-col cols="6">
                                                    <span class="text-body-2">IMPUESTO</span>
                                                </v-col>
                                                <v-col cols="6" class="text-right">
                                                    <span class="font-weight-bold">
                                                        {{ orderLocal.OrdTaxAmount | numberDefault }}
                                                    </span>
                                                </v-col>
                                            </v-row>

                                            <v-divider></v-divider>

                                            <!-- TOTAL -->
                                            <v-row dense align="center" no-gutters class="primary lighten-5 py-2 px-2">
                                                <v-col cols="6">
                                                    <span class="font-weight-bold">TOTAL</span>
                                                </v-col>
                                                <v-col cols="6" class="text-right">
                                                    <span class="text-h6 font-weight-bold primary--text">
                                                        {{ orderLocal.OrdTotal | numberDefault }}
                                                    </span>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>

                        </v-col>
                        <v-col lg="3">
                            <v-card>
                                <v-col>
                                    <v-row>
                                        <v-col class="s-col-text">
                                            <s-select-Campaign :disabled="!isEditable" label="Campaña"
                                                v-model="orderLocal.CmpID" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="s-col-text">
                                            <s-text :maxlength="20" label="N° Cotización" :disabled="!isEditable"
                                                v-model="orderLocal.QuoteNumber" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="s-col-text">
                                            <s-select-definition :disabled="!isEditable" label="Clase de Operación"
                                                v-model="orderLocal.ClassOperationPurchase" :def="1147" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="s-col-text">
                                            <s-select-definition :disabled="!isEditable" label="Tipo Compra" :def="1146"
                                                v-model="orderLocal.TypePurchase" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col lg="12" class="s-col-form" cols="12">
                                            <s-select :disabled="!isEditable" clearable label="Bienes y Servicios"
                                                :items="goodServiceList" item-text="DedDescription"
                                                item-value="DedValue" v-model="orderLocal.OrdGoodService" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="s-col-text">
                                            <s-textarea :disabled="!isEditable && !$fun.hasSpecialPermission('EditObservationApproved')" label="Comentarios"
                                                v-model="orderLocal.OrdObservation" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col lg="12" class="s-col-text" cols="12">
                                            <v-row>
                                                <v-col lg="10" cols="10">
                                                    <v-file-input ref="fileInputAnexo1" :disabled="!isEditable"
                                                        label="Anexo 01" v-model="Attach1" hide-details />
                                                </v-col>
                                                <v-col>
                                                    <v-btn color="success" class="mt-5" :disabled="false" icon x-small
                                                        @click="openFile(Attach1)">
                                                        <v-icon>mdi-download</v-icon>
                                                    </v-btn>
                                                    <v-btn color="primary" class="mt-5" :disabled="!Attach1" icon
                                                        x-small @click="showPreviewDialog(Attach1)" v-if="!value">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col lg="12" class="s-col-text" cols="12">
                                            <v-row>
                                                <v-col lg="10" cols="10">
                                                    <v-file-input :disabled="!isEditable" label="Anexo 02"
                                                        v-model="Attach2" hide-details />
                                                </v-col>
                                                <v-col>
                                                    <v-btn color="success" class="mt-5" :disabled="false" icon x-small
                                                        @click="openFile(Attach2)">
                                                        <v-icon>mdi-download</v-icon>
                                                    </v-btn>
                                                    <v-btn color="primary" class="mt-5" :disabled="!Attach2" icon
                                                        x-small @click="showPreviewDialog(Attach2)" v-if="!value">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col lg="12" class="s-col-text" cols="12">
                                            <v-row>
                                                <v-col lg="10" cols="10">
                                                    <v-file-input :disabled="!isEditable" label="Anexo 03"
                                                        v-model="Attach3" hide-details />
                                                </v-col>
                                                <v-col>
                                                    <v-btn color="success" class="mt-5" :disabled="false" icon x-small
                                                        @click="openFile(Attach3)">
                                                        <v-icon>mdi-download</v-icon>
                                                    </v-btn>
                                                    <v-btn color="primary" class="mt-5" :disabled="!Attach3" icon
                                                        x-small @click="showPreviewDialog(Attach3)" v-if="!value">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col lg="12" class="s-col-text" cols="12">
                                            <v-row>
                                                <v-col lg="10" cols="10">
                                                    <v-file-input :disabled="!isEditable" label="Anexo 04"
                                                        v-model="Attach4" hide-details />
                                                </v-col>
                                                <v-col>
                                                    <v-btn color="success" class="mt-5" :disabled="false" icon x-small
                                                        @click="openFile(Attach4)">
                                                        <v-icon>mdi-download</v-icon>
                                                    </v-btn>
                                                    <v-btn color="primary" class="mt-5" :disabled="!Attach4" icon
                                                        x-small @click="showPreviewDialog(Attach4)" v-if="!value">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-card>
        </v-card>


        <!-- BOTTOM TAB PANEL -->
        <div class="ios-tab-panel">

            <!-- Tab Bar -->
            <div class="ios-tab-bar">
                <!-- Tab 1: Niveles de Aprobación -->
                <button class="ios-tab-btn" :class="{ active: activeBottomTab === 0 }" @click="activeBottomTab = 0">
                    <span class="ios-tab-icon">
                        <v-icon small
                            :color="activeBottomTab === 0 ? '#028a9f' : '#04abc5'">mdi-shield-check-outline</v-icon>
                    </span>
                    <span class="ios-tab-label">Niveles de Aprobación</span>
                    <span v-if="activeBottomTab === 0" class="ios-tab-indicator"></span>
                </button>

                <!-- Tab 2: Entradas de Mercancía — solo si OrdStatus=4 y TypeOrder=1 -->
                <button
                    v-if="ShowOptionsSupply == 1 && [5, 9, 10].includes(orderLocal.OrdStatus) && orderLocal.TypeOrder == 1"
                    class="ios-tab-btn" :class="{ active: activeBottomTab === 1 }" @click="activeBottomTab = 1">
                    <span class="ios-tab-icon">
                        <v-icon small
                            :color="activeBottomTab === 1 ? '#028a9f' : '#04abc5'">mdi-package-variant-closed</v-icon>
                    </span>
                    <span class="ios-tab-label">Entradas de Mercancía</span>
                    <span class="ios-tab-badge">SAP</span>
                    <span v-if="activeBottomTab === 1" class="ios-tab-indicator"></span>
                </button>

                <!-- Tab 2: Entradas de Mercancía — solo si OrdStatus=4 y TypeOrder=3 -->
                <button
                    v-if="ShowOptionsSupply == 1 && [5, 9, 10].includes(orderLocal.OrdStatus) && orderLocal.TypeOrder == 3"
                    class="ios-tab-btn" :class="{ active: activeBottomTab === 2 }" @click="activeBottomTab = 2">
                    <span class="ios-tab-icon">
                        <v-icon small
                            :color="activeBottomTab === 2 ? '#028a9f' : '#04abc5'">mdi-package-variant-closed</v-icon>
                    </span>
                    <span class="ios-tab-label">Entradas de Servicio</span>
                    <span class="ios-tab-badge">SUNEXPERT</span>
                    <span v-if="activeBottomTab === 2" class="ios-tab-indicator"></span>
                </button>

                <!-- Tab 3: Generar Factura Proveedor — solo si OrdStatus=5 y TypeOrder=3 -->
                <button v-if="ShowOptionsSupply == 1 && [5, 9, 10].includes(orderLocal.OrdStatus)" class="ios-tab-btn"
                    :class="{ active: activeBottomTab === 3 }" @click="activeBottomTab = 3">
                    <span class="ios-tab-icon">
                        <v-icon small
                            :color="activeBottomTab === 3 ? '#028a9f' : '#04abc5'">mdi-receipt-text-check</v-icon>
                    </span>
                    <span class="ios-tab-label">Factura Proveedor</span>
                    <span class="ios-tab-badge">SAP</span>
                    <span v-if="activeBottomTab === 3" class="ios-tab-indicator"></span>
                </button>
            </div>

            <!-- Tab Content -->
            <div class="ios-tab-content">
                <transition name="ios-fade" mode="out-in">
                    <div v-if="activeBottomTab === 0" key="tab-approval" class="ios-tab-pane">
                        <v-row dense>
                            <v-col cols="12" md="9">
                                <ApprovalLevelsDocument :DocEntry="orderLocal.OrdID" :TypeObject="2"
                                    :showButtonClose="false" />
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Panel 1: Entradas de Mercancía Artículos -->
                    <PurchaseDeliveryNote :orderLocal="orderLocal"
                        v-else-if="ShowOptionsSupply == 1 && activeBottomTab === 1 && [5, 9, 10].includes(orderLocal.OrdStatus) && orderLocal.TypeOrder == 1"
                        key="tab-grcs" @SavedDeliveryNote="initializeOrderSaved()" />

                    <!-- Panel 2: Entradas de Servicios -->
                    <div v-else-if="ShowOptionsSupply == 1 && activeBottomTab === 2 && [5, 9, 10].includes(orderLocal.OrdStatus) && orderLocal.TypeOrder == 3"
                        key="tab-srvcs" class="ios-tab-pane">
                        <ServiceOrderActivity :order="orderLocal" />
                    </div>

                    <!-- Panel 3: Generar Factura Proveedor -->
                    <PurchaseInvoice :orderLocal="orderLocal"
                        v-else-if="ShowOptionsSupply == 1 && activeBottomTab === 3" key="tab-invoice"
                        @SavedInvoice="initializeOrderSaved()" />
                </transition>
            </div>
        </div>
    </div>
</template>
<!-- </s-crud></v-col> </v-row>
 </div>
</template> -->
<script>
import * as XLSX from 'xlsx';
import mammoth from 'mammoth';

import OrderAttentionPurchase from "@/views/Logistics/OrderStore/OrderPurcharseAttentionAdd.vue";
import OrderAttentionService from "@/views/Logistics/Requirement/ServiceAttentionAdd.vue";
import _sApprovalTransaction from "../../../services/Security/ApprovalTransactionService";
import SContactSupplier from "../../../components/Utils/Logistics/SContactSupplier.vue";
import SSupplier from "../../../components/Utils/Logistics/SSupplier.vue";
import _sRequirementDetail from "../../../services/Logistics/RequirementDetailService";
import _sRequirement from "../../../services/Logistics/RequirementService";
import _sGeneral from "@/services/HelperService.js";
import _sOrderPurchase from "../../../services/Logistics/OrderPurchaseService"; // servicio tabla
import SCircuitApproval from "../../../components/Utils/Security/SCircuitApproval.vue";
import _sApprovalLevel from "@/services/Security/ApprovalLevelsService";
import SSelectBusinessLine from "../../../components/Utils/SSelectBusinessLine.vue";
import _GenUploadFiles from "../../../services/General/GenUploadFiles";
import SSelectPaymentterms from "../../../components/logistics/SSelectPaymentterms.vue";
import _sApproval from "@/services/Logistics/OrderPurchaseApproval";
import _sGenParam from "@/services/General/ParameterService";
import ApprovalLevelsDocument from "@/views/Security/Circuit/Levels/ApprovalLevelsDocument";
import _sSaleOrder from "@/services/ExternalTrade/SaleOrderService.js";
import ServiceOrderActivity from "@/views/Logistics/OrderPurchase/ServiceOrderActivity.vue";
import PurchaseDeliveryNote from "@/views/Logistics/OrderPurchase/PurchaseDeliveryNote.vue";
import PurchaseInvoice from '@/views/Logistics/OrderPurchase/PurchaseInvoice.vue';

export default {
    name: "OrderPurchaseEdit",
    components: {
        SSelectPaymentterms,
        SSupplier,
        SContactSupplier,
        SCircuitApproval,
        SSelectBusinessLine,
        OrderAttentionPurchase,
        OrderAttentionService,
        ApprovalLevelsDocument,
        ServiceOrderActivity,
        PurchaseDeliveryNote,
        PurchaseInvoice
    },
    props: {
        order: {},
        value: null,
        typeOrder: null,
        viewLoad: { type: Boolean, default: true },
        isStatusActive: { type: Boolean, default: false },
        isEditableOC: { type: Boolean, default: false },
        isTransport: { type: Boolean, default: false },
        initialAttach1: { type: File, default: null },
    },
    data: () => ({
        UseServiceLayer: null,
        ShowOptionsSupply: 0,
        urlWhatsApp1: "",
        urlWhatsApp2: "",
        numberWhatsAppAPI: "",
        tokenWhatsAppAPI: "",
        formSubmitted: false,
        itemsDataTotal: [],
        dialogTax: false,
        selectedTax: false,
        selectedrow: [],
        circuits: [],
        itemsCom: [{ OddDescription: "ss" }],
        message: "",
        processing: false,
        PytID: null,
        selectedCircuit: [],
        validarFila: { type: Boolean, default: true },
        filterLevels: {},
        configLevels: {
            model: {
                AccID: "int",
                AlvID: "ID",
                SecStatus: "boleam",
                PstID: "int",
                PstName: "string",
                OddAmount: "",
                OddUnitPrice: "",
                TaxCode: "",
            },
            service: _sApprovalLevel,
            headers: [
                { text: "Cargo", value: "PstName" },
                { text: "Nivel", value: "TypeLevelText" },
            ],
        },
        loadingCard: false,
        loading: false,
        optionApproved: false,
        dateOrder: null,
        selectedSAP: [],
        transactionApproved: null,
        tax: null,
        dialogCircuit: false,
        searchCircuit: "",
        orderLocal: {

        },
        dialogAdd: false,
        itemsConcept: [],
        itemsAccount: [],
        AcoID: null,
        ConID: null,
        ConName: null,
        SupID: "",
        Supplier: null,
        itemsSAP: [],
        itemsRemove: [],
        dialogLoad: false,
        Attach1: null,
        Attach2: null,
        Attach3: null,
        Attach4: null,
        previewDialog: false,
        previewUrl: null,
        previewType: null,
        currentFile: null,
        excelData: [],
        excelSheets: [],
        currentSheet: 0,
        wordContent: '',
        goodServiceList: [],
        OrdStatusValue: null,
        activeBottomTab: 0,
        headersSAP: [
            { text: "", value: "action", sortable: false, width: 40 },
            { text: "Código", value: "ArtCode", sortable: false, width: 70 },
            { text: "Descripción", value: "OddDescriptionNew", sortable: false, width: 540 },
            { text: "Prc. U.", value: "OddUnitPrice", width: 90 },
            { text: "% Descuento", value: "OddDiscountPercentage", sortable: false, width: 90 },
            { text: "Monto Desc.", value: "OddDiscount", sortable: false, width: 90, align: "right" },
            { text: "Impuesto", value: "TaxCode", sortable: false, width: 60 },
            { text: "(%)Imp", value: "OddTaxPercentage", sortable: false, width: 70 },
            { text: "tax", value: "OddTaxAmount", sortable: false, width: 70, align: "right" },
            { text: "SubTotal", value: "OddAmount", sortable: false, width: 100, align: "right" },
            { text: "Centro Costo", value: "CceName", sortable: false, width: 300 },
            { text: "Linea de Negocio", value: "BslName", sortable: false, width: 300 },
            { text: "Tipo Costo", value: "TypeCostName", sortable: false, width: 100 },
            { text: "Proyecto", value: "PrjName", sortable: false, width: 300 },
            { text: "Comentario", value: "OddObservation", sortable: false, width: 400 },
            { text: "Fecha de solicitud", value: "SecCreateReq", sortable: false, width: 180 },
            { text: "Area solicitante", value: "AreNameReq", sortable: false, width: 180 },
            { text: "Tipo de Prioridad", value: "TypePriorityName", sortable: false, width: 180 },
            // { text: "Dias de entrega", value: "OddDaysDelivery", sortable: false, width: 95, align: "center" },
        ],
        ordData: {},
        isUpdateAccount: false,
        numberDefault: '0.00',
    }),
    computed: {

        isEditable() {
            return (
                (this.orderLocal.OrdStatus == 3 &&
                    this.$fun.getUserID() == this.orderLocal.UsrCreateID) ||
                this.orderLocal.OrdID == null || ((this.orderLocal.IsEditOrder == 1 && this.isEditableOC) && this.$fun.getUserID() == this.orderLocal.UsrCreateID)
            );

        },

        // orderCreateEditable () {
        //   return (
        //     (this.orderLocal.OrdStatus== 3 &&
        //       this.$fun.getUserID() == this.orderLocal.UsrCreateID)
        //   );
        // },

    },
    methods: {

        getGoodServiceList() {
            _sRequirement.goodservicelist(this.$fun.getUserID()).then(resp => {
                if (resp.status == 200) {
                    console.log("Data q traeeee", resp.data);
                    this.goodServiceList = resp.data;
                }
            })
        },

        downloadPdf() {

            this.$emit("download", this.orderLocal);
        },

        addItem(item) {

            if (item.duplicateLine) {

                let lineDelete = item.Line - 1;
                this.itemsSAP.splice(lineDelete, 1)

                for (let i = 0; i < this.itemsSAP.length; i++) {
                    this.itemsSAP[i].Line = i + 1;
                }

            } else {

                let newItem = Object.assign({}, item);
                newItem.duplicateLine = true;
                newItem.Line = this.itemsSAP.length + 1;
                newItem.OddID = null;
                this.itemsSAP.push(newItem);


                // this.validarFila = false
            }
            this.changeTotal();
        },
        deleteitem(item) {
            console.log("eliminar item", item);
            let lineDelete = item.Line - 1;
            this.itemsSAP.splice(lineDelete, 1)

            for (let i = 0; i < this.itemsSAP.length; i++) {
                this.itemsSAP[i].Line = i + 1;
            }
            if (item.OddID > 0) {
                item.OddStatus = 0;
                this.itemsRemove.push(item);
            }

            this.changeTotal();
        },
        openFile(url) {
            console.log("dow", url.name);
            _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
                this.$fun.download(r.data, url.name);
            });
        },
        selectedAttention(items) {
            const incoming = Array.isArray(items) ? items : [];
            // Evitar duplicados por DerID (línea de requerimiento)
            const existingDerIDs = new Set(
                this.itemsSAP
                    .filter(x => x && x.DerID != null)
                    .map(x => x.DerID)
            );

            const toAdd = incoming.filter(it => it && (it.DerID == null || !existingDerIDs.has(it.DerID)));
            const skipped = incoming.length - toAdd.length;

            if (toAdd.length > 0) {
                // Normalizar y mapear campos requeridos antes de insertar
                if (toAdd[0]) toAdd[0].OddID = 0;
                for (let i = 0; i < toAdd.length; i++) {
                    const it = toAdd[i];
                    it.OddDescription = it.DerDescription;
                    it.OddQuantity = it.DerQuantity;
                    if (this.orderLocal.TypeOrder == 3) {
                        it.OddQuantity = it.DerQuantity;
                        it.OddAccount = it.ReqAccount;
                    }
                    it.OddObservation = it.DerObservation;
                    it.Line = this.itemsSAP.length + i + 1;
                }
                this.itemsSAP.push(...toAdd);
                this.changeTotal();
                this.configureHeadersSAP();
            }

            if (skipped > 0) {
                this.$fun.alert(`${skipped} item(s) ya estaban agregados y fueron omitidos.`, 'info');
            }

            this.dialogAdd = false;
        },
        removeItem() {

            if (this.selectedSAP.length == 1) {
                if (this.itemsSAP.length <= 1) {
                    this.$fun.alert(
                        "No se permite eliminar el ultimo item de la orden",
                        "warning"
                    );
                    return;
                }
                this.itemsSAP = this.itemsSAP.filter(
                    (x) => x.OddID != this.selectedSAP[0].OddID
                );
                this.selectedSAP[0].OddStatus = 0;

                if (this.selectedSAP[0].OddID > 0)
                    this.itemsRemove.push(this.selectedSAP[0]);
                this.changeTotal();
            }
        }, ////
        changeTotal() {
            this.calculateTotals();
        },
        calculatePercent() {
            let sOrdTotal = 0;
            let sOrdTaxAmount = 0;

            this.itemsSAP.forEach((element) => {
                let itemTotal = parseFloat(element.OddAmount || 0);
                let itemTax = parseFloat(element.OddTaxAmount || 0);

                if (!element.OddAmount) {
                    let price = parseFloat(element.OddUnitPrice || 0);
                    let qty = parseFloat(element.OddQuantity || 1);
                    itemTotal = price * qty;
                    let taxP = parseFloat(element.OddTaxPercentage || 0);
                    itemTax = itemTotal * (taxP / 100);
                    itemTotal += itemTax;
                }

                sOrdTotal += itemTotal;
                sOrdTaxAmount += itemTax;
            });

            let ordSubTotal = sOrdTotal - sOrdTaxAmount;
            let generalDiscountAmount = parseFloat(this.orderLocal.OrdDiscountAmount || 0);

            let generalDiscountPercent = 0;
            if (ordSubTotal !== 0) {
                generalDiscountPercent = (generalDiscountAmount / ordSubTotal) * 100;
            }

            let effectiveTaxAmount = sOrdTaxAmount * (1 - generalDiscountPercent / 100);
            let finalTotal = (ordSubTotal - generalDiscountAmount) + effectiveTaxAmount;

            this.orderLocal.OrdDiscountPercentage = parseFloat(generalDiscountPercent.toFixed(3));
            this.orderLocal.OrdSubTotal = parseFloat(ordSubTotal.toFixed(4));
            this.orderLocal.OrdTaxAmount = parseFloat(effectiveTaxAmount.toFixed(4));
            this.orderLocal.OrdTotal = parseFloat(finalTotal.toFixed(4));
        },
        calculateTotals() {
            let sOrdTotal = 0;
            let sOrdTaxAmount = 0;

            this.itemsSAP.forEach((element) => {
                let itemTotal = parseFloat(element.OddAmount || 0);
                let itemTax = parseFloat(element.OddTaxAmount || 0);

                if (!element.OddAmount) {
                    let price = parseFloat(element.OddUnitPrice || 0);
                    let qty = parseFloat(element.OddQuantity || 1);
                    itemTotal = price * qty;
                    let taxP = parseFloat(element.OddTaxPercentage || 0);
                    itemTax = itemTotal * (taxP / 100);
                    itemTotal += itemTax;
                }

                sOrdTotal += itemTotal;
                sOrdTaxAmount += itemTax;
            });

            let ordSubTotal = sOrdTotal - sOrdTaxAmount;

            let generalDiscountPercent = parseFloat(this.orderLocal.OrdDiscountPercentage || 0);
            let generalDiscountAmount = ordSubTotal * (generalDiscountPercent / 100);

            let effectiveTaxAmount = sOrdTaxAmount * (1 - generalDiscountPercent / 100);
            let finalTotal = (ordSubTotal - generalDiscountAmount) + effectiveTaxAmount;

            this.orderLocal.OrdDiscountAmount = generalDiscountAmount.toFixed(2);
            this.orderLocal.OrdSubTotal = parseFloat(ordSubTotal.toFixed(4));
            this.orderLocal.OrdTaxAmount = parseFloat(effectiveTaxAmount.toFixed(4));
            this.orderLocal.OrdTotal = parseFloat(finalTotal.toFixed(4));
        },
        blurQuantity(event, item) {
            if (item.ReqID != null) {
                if (item.DerQuantity < item.OddQuantity || item.OddQuantity <= 0) {
                    this.$fun.alert("Cantidad Incorrecta", "warning");
                    item.OddQuantity = item.DerQuantity;

                    //this.itemsSAP.splice(this.itemsSAP.indexOf(item),1,item);
                }
            }
            this.changeItem(item);
        },

        pasteQuantity(event) {
            event.preventDefault();
            let quantitys = [];
            let i = 0;
            let isValid = true;
            event.clipboardData
                .getData("text/plain")
                .split("\n")
                .forEach((element) => {
                    if (element.trim() != "") {
                        quantitys[i] = parseFloat(element.trim());
                        if (Number.isNaN(quantitys[i])) {
                            this.$fun.alert("Datos incorrectos", "warning");
                            isValid = false;
                        }
                        i++;
                    }
                });
            if (isValid == true)
                for (i = 0; i < this.itemsSAP.length && i < quantitys.length; i++) {
                    this.itemsSAP[i].OddQuantity = quantitys[i];
                    this.changeItem(this.itemsSAP[i]);
                }
        },
        handlePaste(event) {
            event.preventDefault();
            const pasteData = (event.clipboardData || window.clipboardData).getData('text');
            const numericPasteData = pasteData.replace(/[^0-9.]/g, '');
            const parts = numericPasteData.split('.');
            if (parts.length > 2) {
                document.execCommand('insertText', false, parts[0] + '.' + parts.slice(1).join(''));
            } else {
                document.execCommand('insertText', false, numericPasteData);
            }
        },
        pastePrice(event) {

            event.preventDefault();
            let quantitys = [];
            let i = 0;
            let isValid = true;
            event.clipboardData
                .getData("text/plain")
                .split("\n")
                .forEach((element) => {
                    if (element.trim() != "") {
                        quantitys[i] = parseFloat(element.trim());
                        if (Number.isNaN(quantitys[i])) {
                            this.$fun.alert("Datos incorrectos", "warning");
                            isValid = false;
                        }
                        i++;
                    }
                });
            if (isValid == true)
                for (i = 0; i < this.itemsSAP.length && i < quantitys.length; i++) {
                    // Limitar a 6 decimales al pegar
                    this.itemsSAP[i].OddUnitPrice = this.trimDecimals(quantitys[i], 6);
                    this.changeItem(this.itemsSAP[i]);
                }
        },

        trimDecimals(value, maxDecimals) {
            if (value === null || value === undefined || value === "") return value;
            // Asegurar que sea número
            let n = Number(String(value).replace(/,/g, '.'));
            if (Number.isNaN(n)) return value;
            const factor = Math.pow(10, maxDecimals);
            return Math.round(n * factor) / factor;
        },

        loadExternal() {
            this.$fun.alert("Seguro de Cargar Orden?", "question")
                .then(async (r) => {
                    if (r.value) {
                        // this.processing = true;
                        this.orderLocal.PytID = this.PytID;

                        console.log("this.orderLocal:", this.orderLocal);

                        const UsrID = this.orderLocal.UsrID;
                        const itemRespuesta = [];
                        await _sApproval.listPerson(UsrID, this.$fun.getUserID())
                            .then((r) => {
                                if (r.status == 200) {
                                    itemRespuesta.push(r.data[0]);
                                }
                            });

                        const NtpFullNameSupplier = itemRespuesta[0].NtpFullNameSupplier;
                        const message = `Estimado(a) ${itemRespuesta[0].NtpFullName}, se le informa que su requerimiento que pertenece a la orden de compra : ${this.orderLocal.OrdDocumentNumber} al proveedor ${this.orderLocal.SupName} por el monto de ${this.orderLocal.TypeCurrencyName} ${this.orderLocal.OrdTotal} ha sido cargada a SAP por ${NtpFullNameSupplier}.`;
                        const PpnNumberPhone = itemRespuesta[0].PpnNumberPhone;

                        // await this.$fun.sendWhatsAppMessage(this.urlWhatsApp1, this.numberWhatsAppAPI, this.urlWhatsApp2, this.tokenWhatsAppAPI, message, PpnNumberPhone);

                        _sOrderPurchase
                            .loadExternal(
                                this.orderLocal,
                                this.$fun.getUserID(),
                                this.$fun.getUserID()
                            )
                            .then(
                                (r) => {
                                    this.processing = false;
                                    this.$fun.alert("Cargado Correctamente", "success");
                                    this.$emit("onClose");
                                },
                                (e) => {
                                    this.message = e.response.data.Message;
                                    this.processing = true;
                                    let messageInclude = 'Orden de Compra ya fue cargada en SAP'
                                    let includeMessageLoadSap = this.message.includes(messageInclude);
                                    if (includeMessageLoadSap) {
                                        /* Con esto actualizamos el estado a subido a sap */
                                        // this.orderLocal.OrdStatus = 100;
                                        this.orderLocal.OrdStatus = 5;
                                        _sOrderPurchase.setStatus(this.orderLocal, this.$fun.getUserID()).then((r) => {
                                            this.$refs.crud.refresh();
                                        });
                                    }
                                }
                            );
                    }
                });
        },
        async saveDemo() {
            console.log(JSON.parse(JSON.stringify({ orderLocal: this.orderLocal })))

            this.$fun.alert("Seguro de Cargar Orden?", "question").then(async (r) => {
                if (r.value) {
                    // this.processing = true;
                    this.orderLocal.PytID = this.PytID;

                    const UsrID = this.orderLocal.UsrID;
                    const itemRespuesta = [];
                    await _sApproval.listPerson(UsrID, this.$fun.getUserID()).then((r) => {
                        if (r.status == 200) {
                            itemRespuesta.push(r.data[0]);
                        }
                    });

                    const NtpFullNameSupplier = itemRespuesta[0].NtpFullNameSupplier;
                    const message = `Estimado(a) ${itemRespuesta[0].NtpFullName}, se le informa que su requerimiento que pertenece a la orden de compra : ${this.orderLocal.OrdDocumentNumber} al proveedor ${this.orderLocal.SupName} por el monto de ${this.orderLocal.TypeCurrencyName} ${this.orderLocal.OrdTotal} ha sido cargada a SAP por ${NtpFullNameSupplier}.`;
                    const PpnNumberPhone = itemRespuesta[0].PpnNumberPhone;

                    // await this.$fun.sendWhatsAppMessage(this.urlWhatsApp1, this.numberWhatsAppAPI, this.urlWhatsApp2, this.tokenWhatsAppAPI, message, PpnNumberPhone);

                    _sOrderPurchase.loadExternalDemo(this.orderLocal, this.$fun.getUserSAPInfo().UsrID, this.$fun.getUserID()).then((r) => {
                        this.processing = false;
                        this.$fun.alert("Cargado Correctamente", "success");
                        if (this.order.QuoteNumber) {
                            this.$emit("onOrderCreated", { QuoteNumber: this.order.QuoteNumber });
                        }
                        this.$emit("onClose");
                    },
                        (e) => {
                            this.message = e.response.data.Message;
                            this.processing = true;
                            let messageInclude = 'Orden de Compra ya fue cargada en SAP'
                            let includeMessageLoadSap = this.message.includes(messageInclude);
                            if (includeMessageLoadSap) {
                                /* Con esto actualizamos el estado a subido a sap */
                                // this.orderLocal.OrdStatus = 100;
                                this.orderLocal.OrdStatus = 5;
                                // _sOrderPurchase.setStatus(this.orderLocal, this.$fun.getUserID()).then((r) => {
                                //   this.$refs.crud.refresh();
                                // });
                            }
                        }
                    );
                }
            });
        },
        async updateOddAccount() {
            console.log("Actualizando datos antes de aprobar...");

            if (this.orderLocal.OrdID && this.$fun.hasSpecialPermission('EditObservationApproved')) {
                try {
                    await _sOrderPurchase.updateObservation({
                        OrdID: this.orderLocal.OrdID,
                        OrdObservation: this.orderLocal.OrdObservation
                    }, this.$fun.getUserID());
                } catch (errObs) {
                    console.error("Error al actualizar observación al aprobar:", errObs);
                }
            }

            if (!this.isUpdateAccount) return;
            if (!this.itemsSAP || this.itemsSAP.length === 0) return;

            try {
                const promises = this.itemsSAP.map(item => {
                    if (item.OddID && item.OddAccount) {
                        const payload = {
                            OddID: item.OddID,
                            OddAccount: item.OddAccount
                        };

                        return _sOrderPurchase.updateAccountDetail(payload, this.$fun.getUserID());
                    }
                });

                const results = await Promise.all(promises);

                const allSuccess = results.every(r => r && r.status === 200);

                if (allSuccess) {
                    this.$fun.alert("Cuentas actualizadas correctamente", "success");
                }

            } catch (error) {
                console.error(error);
                this.$fun.alert("Error al actualizar algunas cuentas", "error");
            }
        },
        rowClickCircuit: function (item, row) {
            this.selectedCircuit = [item];
            this.filterLevels = { AccID: item.AccID };
        },
        createCircuit(item) {
            console.log("ordData", this.ordData);
            this.$fun
                .alert("Guardar con " + this.selectedCircuit[0].AccName, "question")
                .then((r) => {
                    if (r.value) {
                        this.orderLocal.UsrUpdateID = this.selectedCircuit[0].AccID;
                        this.ordData.UsrUpdateID = this.selectedCircuit[0].AccID;
                        this.ordData.SecStatus = 1;
                        this.dialogCircuit = false;
                        this.orderLocal.Detail = this.itemsSAP;
                        this.ordData.OrdStatus = 4;
                        // this.orderLocal.Detail = [];

                        _sOrderPurchase
                            .save(
                                this.ordData,
                                this.$fun.getUserID(),
                                this.selectedCircuit[0].AccID
                            )
                            .then((r) => {
                                if (this.isTransport) {
                                    this.$emit("orderSaved", { Order: this.ordData });
                                }

                                this.$emit("onCloseClear");
                                this.$fun.alert("Agregado Correctamente", "success");
                                this.$emit("close");
                                if (this.order.QuoteNumber) {
                                    this.$emit("onOrderCreated", { QuoteNumber: this.order.QuoteNumber });
                                }
                                this.$emit("onClose");
                                if (this.typeOrder == 3) {
                                    this.$emit("clearItemsCard");
                                } else if (this.typeOrder == 1) {
                                    this.$emit("clearItemsCard");
                                }
                            });
                    }
                });
        },
        changeItemPrc(item) {
            let discountPerc = parseFloat(item.OddDiscountPercentage || 0);
            if (discountPerc < 0) discountPerc = 0;
            if (discountPerc > 100) discountPerc = 100;

            let price = parseFloat(item.OddUnitPrice || 0);
            let quantity = parseFloat(item.OddQuantity || 0);
            let taxPerc = parseFloat(item.OddTaxPercentage || 0);

            let grossAmount = price * quantity;
            let discountAmount = grossAmount * (discountPerc / 100);
            let netSubTotal = grossAmount - discountAmount;

            let taxAmount = netSubTotal * (taxPerc / 100);
            let totalAmount = netSubTotal + taxAmount;

            item.OddTaxAmount = parseFloat(taxAmount.toFixed(2));
            item.OddAmount = parseFloat(totalAmount.toFixed(2));
            item.OddDiscount = parseFloat(discountAmount.toFixed(2));

            // Recalcular totales globales
            this.calculateTotals();
        },
        changeItemDiscount(item) {
            let discountAmount = parseFloat(item.OddDiscount || 0);
            let price = parseFloat(item.OddUnitPrice || 0);
            let quantity = parseFloat(item.OddQuantity || 0);
            let taxPerc = parseFloat(item.OddTaxPercentage || 0);

            let grossAmount = price * quantity;
            let discountPerc = 0;
            if (grossAmount > 0) {
                discountPerc = (discountAmount / grossAmount) * 100;
            }
            if (discountPerc < 0) discountPerc = 0;
            if (discountPerc > 100) discountPerc = 100;

            let netSubTotal = grossAmount - discountAmount;
            let taxAmount = netSubTotal * (taxPerc / 100);
            let totalAmount = netSubTotal + taxAmount;

            item.OddDiscountPercentage = parseFloat(discountPerc.toFixed(3));
            item.OddTaxAmount = parseFloat(taxAmount.toFixed(2));
            item.OddAmount = parseFloat(totalAmount.toFixed(2));

            this.calculateTotals();
        },
        changeItem(item) {

            this.orderLocal.OrdSubTotal = 0;
            this.orderLocal.OrdTaxAmount = 0;
            let edit = Object.assign(
                {},
                this.itemsSAP.find((x) => x.Line == item.Line)
            );
            // Normalizar precio unitario a máximo 6 decimales
            if (edit.OddUnitPrice !== null && edit.OddUnitPrice !== undefined && edit.OddUnitPrice !== "") {
                edit.OddUnitPrice = this.trimDecimals(edit.OddUnitPrice, 6);
            }
            let indexEdit = this.itemsSAP.indexOf(item);
            if (edit.CceObject) {
                let cce = edit.CceID;
                edit.CceID = edit.CceObject.GenID;
                edit.CceName = edit.CceObject.GenDescription;
                if (edit.CceObject.GenID != cce) {
                    edit.BslID = null;
                    edit.BslName = "";
                } else {
                    if (edit.BslObject) {
                        edit.BslID = edit.BslObject.GenID;
                        edit.BslName = edit.BslObject.GenDescription;
                    }
                }
            }
            if (edit.TypeCostObject) {
                edit.TypeCost = edit.TypeCostObject.DedValue;
                edit.TypeCostName = edit.TypeCostObject.DedDescription;
            }

            let price = parseFloat(edit.OddUnitPrice || 0);
            let quantity = parseFloat(edit.OddQuantity || 0);
            let discountPerc = parseFloat(edit.OddDiscountPercentage || 0);
            let taxPerc = parseFloat(edit.OddTaxPercentage || 0);

            let grossAmount = price * quantity;
            if (discountPerc === 0 && parseFloat(edit.OddDiscount || 0) > 0 && grossAmount > 0) {
                discountPerc = (parseFloat(edit.OddDiscount) / grossAmount) * 100;
                edit.OddDiscountPercentage = parseFloat(discountPerc.toFixed(3));
            }
            let discountAmount = grossAmount * (discountPerc / 100);
            let netSubTotal = grossAmount - discountAmount;

            let taxAmount = netSubTotal * (taxPerc / 100);
            let totalAmount = netSubTotal + taxAmount;

            edit.OddTaxAmount = parseFloat(taxAmount.toFixed(2));
            edit.OddAmount = parseFloat(totalAmount.toFixed(2));
            edit.OddDiscount = parseFloat(discountAmount.toFixed(2));

            this.itemsSAP.splice(indexEdit, 1, edit);

            this.calculateTotals();
        },
        changeSubTotal(item, newValue) {
            if (newValue !== undefined) {
                item.OddAmount = newValue;
            }
            if (item.OddAmount === "" || item.OddAmount == null) return;

            let subTotalTotal = parseFloat(item.OddAmount);
            let price = parseFloat(item.OddUnitPrice || 0);
            let quantity = parseFloat(item.OddQuantity || 0);
            let taxPercent = parseFloat(item.OddTaxPercentage || 0);

            let grossAmount = price * quantity;
            if (grossAmount === 0) return;

            let taxFactor = 1 + (taxPercent / 100);
            let netSubTotal = subTotalTotal / taxFactor;
            let discountAmount = grossAmount - netSubTotal;
            let discountPercent = (discountAmount / grossAmount) * 100;

            if (discountPercent < 0) discountPercent = 0;
            if (discountPercent > 100) discountPercent = 100;

            item.OddDiscountPercentage = parseFloat(discountPercent.toFixed(3));
            item.OddDiscount = parseFloat(discountAmount.toFixed(2));

            item.OddTaxAmount = parseFloat((netSubTotal * (taxPercent / 100)).toFixed(6));

            this.calculateTotals();
        },
        rowClick: function (item, row) {
            this.selectedSAP = [item];

            //this.selectedrow=item;
            //this.selectedrow.Line=this.selectedrow.Line+1;

        },
        saveAccount(item) {
            if (this.AcoID != null) {
                let edit = this.itemsSAP.find((x) => x.Line == item.Line);
                let indexEdit = this.itemsSAP.indexOf(item);
                edit.AcoName = this.AcoID.CsaDescription;
                edit.OddAccount = this.AcoID.CsaAccount;
                edit.AcoDescription = this.AcoID.CsaDescription;
                edit.OddAccountName = this.AcoID.CsaAccountName;
                this.itemsSAP.splice(indexEdit, 1, edit);
            }
        },
        changeTax(item) {
            if (this.tax != null)
                if (this.selectedTax) {
                    item.OddTaxPercentage = parseFloat(this.tax.DedHelper).toFixed(4);
                    item.TaxCode = this.tax.DedAbbreviation;
                    this.changeItem(item);
                    this.tax = null;
                } else {
                    this.itemsSAP.forEach((e) => {
                        e.OddTaxPercentage = parseFloat(this.tax.DedHelper).toFixed(4);
                        e.TaxCode = this.tax.DedAbbreviation;
                        this.changeItem(e);
                    });
                    this.selectedTax = true;
                }
        },
        dblClick(item) { },
        async save() {
            console.log("edicion de orden de compra", this.orderLocal);

            this.itemsDataTotal = [];

            if (this.orderLocal.OrdGoodService != null || this.orderLocal.OrdGoodService != undefined) {
                if (this.orderLocal.OrdGoodService == undefined || this.orderLocal.OrdGoodService == 0) {
                    this.$fun.alert("Debe agregar el tipo de bien y servicio", "warning");
                    return;
                }
            }

            if (this.Supplier == null) {
                this.$fun.alert("Falta proveedor", "warning");
                return;
            }
            if (this.orderLocal.TypeCurrency == null) {
                this.$fun.alert("Falta Tipo de Moneda", "warning");
                return;
            }
            if (this.Attach1 == null) {
                this.$fun.alert("Falta adjuntar archivo", "warning");
                return;
            }

            this.order.detail = [];

            for (let i = 0; i < this.itemsSAP.length; i++) {
                if (this.itemsSAP[i].ItemGroupName === 'Activos Fijos' && (!this.itemsSAP[i].PrjCode || this.itemsSAP[i].PrjCode === '00000')) {
                    this.$fun.alert("El articulo " + this.itemsSAP[i].OddDescription + " es activo fijo, debe pertenecer a un proyecto", "warning");
                    return;
                }
                if (
                    this.itemsSAP[i].OddUnitPrice == null ||
                    this.itemsSAP[i].OddUnitPrice == 0
                ) {
                    this.$fun.alert(
                        "Precio inválido, " + this.itemsSAP[i].OddDescription,
                        "warning"
                    );
                    return;
                }
                if (this.itemsSAP[i].CceID == null) {
                    this.$fun.alert(
                        "Falta Centro de Costo en, " + this.itemsSAP[i].OddDescription,
                        "warning"
                    );
                    return;
                }
                if (this.itemsSAP[i].BslID == null) {
                    this.$fun.alert(
                        "Falta Linea de Negocio en, " + this.itemsSAP[i].OddDescription,
                        "warning"
                    );
                    return;
                }
                if (this.itemsSAP[i].TypeCost == null) {
                    this.$fun.alert(
                        "Falta Tipo de Costo, " + this.itemsSAP[i].OddDescription,
                        "warning"
                    );
                    return;
                }
                if (this.itemsSAP[i].TaxCode == null) {
                    this.$fun.alert(
                        "Agrege Impuesto a, " + this.itemsSAP[i].OddDescription,
                        "warning"
                    );
                    return;
                }
                if (this.itemsSAP[i].OddUnitPrice == null || this.itemsSAP[i].OddUnitPrice == 0) {
                    this.$fun.alert(
                        "Precio inválido, " + this.itemsSAP[i].OddDescription,
                        "warning"
                    );
                    return;
                }

                if (this.typeOrder == 3) {
                    if (this.itemsSAP[i].OddAccount == null) {
                        this.$fun.alert(
                            "Agrege Concepto a, " + this.itemsSAP[i].OddDescription,
                            "warning"
                        );
                        return;
                    }
                    this.itemsSAP[i].OddQuantity = this.itemsSAP[i].DerQuantity;
                }

                this.itemsSAP[i].TypeCurrency = this.orderLocal.TypeCurrency;
                this.itemsSAP[i].SisCode = this.itemsSAP[i].SisID;
                this.itemsSAP[i].SitCode = this.itemsSAP[i].SitID;
                this.itemsSAP[i].UsrUpdateID = this.$fun.getUserID();
            }

            this.itemsDataTotal.push(...this.itemsSAP);
            this.itemsDataTotal.push(...this.itemsRemove);

            this.orderLocal.PytID = this.PytID;
            this.orderLocal.SupCode = this.Supplier.SupID;
            this.orderLocal.SupName = this.Supplier.SupName;
            this.orderLocal.OrdAttach1 = this.Attach1 != null ? this.Attach1.name : "";
            this.orderLocal.OrdAttach2 = this.Attach2 != null ? this.Attach2.name : "";
            this.orderLocal.OrdAttach3 = this.Attach3 != null ? this.Attach3.name : "";
            this.orderLocal.OrdAttach4 = this.Attach4 != null ? this.Attach4.name : "";
            this.orderLocal.CardName = this.Supplier.SupName;
            this.orderLocal.OrdDate = this.dateOrder;
            this.orderLocal.UsrUpdateID = this.$fun.getUserID();
            this.orderLocal.OrdDiscuont = this.orderLocal.OrdDiscountAmount || 0;

            const attributesToCompare = ['DerDescription', 'TypeCostName', 'BslName', 'PrjName'];
            let validate = this.findRepeatedObjects(this.itemsDataTotal, attributesToCompare);
            // if(validate)
            // {
            //   this.$fun.alert(
            //       "Existe detalles que se repiten. ",
            //       "warning"
            //     );
            //     return;
            // }

            console.log("this.orderLocal:", this.orderLocal);
            console.log("this.itemsDataTotal:", this.itemsDataTotal);

            // Esperamos la confirmación del usuario
            const confirmResult = await this.$fun.alert("Seguro de guardar?", "question");

            this.$emit("clearItems");

            if (!confirmResult.value) {
                return; // Usuario canceló
            }

            try {
                // Preparamos los archivos para subir
                let files = [];
                if (this.Attach1) files.push(this.Attach1);
                if (this.Attach2) files.push(this.Attach2);
                if (this.Attach3) files.push(this.Attach3);
                if (this.Attach4) files.push(this.Attach4);

                console.log("Files to upload:", files);

                // ✅ Filtrar solo archivos reales (que tengan size y type)
                files = files.filter(file => file && file.size && file.type);

                if (files.length > 0) {
                    var formData = new FormData();
                    let i = 0;
                    files.forEach((element) => {
                        formData.append(i.toString(), element);
                        i++;
                    });

                    console.log("Files to upload:", files);

                    // Subimos los archivos
                    const uploadResponse = await _sGeneral.uploadfile("123", this.$fun.getUserID(), formData, 3);

                    if (uploadResponse.status != 200) {
                        this.$fun.alert("Error al subir archivos", "error");
                        this.formSubmitted = false;
                        return;
                    }
                }

                // Solo continuamos si la subida fue exitosa
                this.orderLocal.Detail = this.itemsDataTotal;

                // Validamos que no se repita la petición
                if (this.formSubmitted) return;
                this.formSubmitted = true;

                console.log(this.orderLocal);

                if (this.OrdStatusValue == 7 && this.orderLocal.OrdStatus == 4) {
                    this.orderLocal.OrdStatus = 0;
                }
                if (!this.value && this.orderLocal.OrdStatus == 4) {
                    this.orderLocal.OrdStatus = 0;
                }

                // Guardamos la orden
                const saveResponse = await _sOrderPurchase.save(this.orderLocal, this.$fun.getUserID(), 0);

                console.log("respuesta de guardado", saveResponse.data);

                if (saveResponse.data.Circuits && saveResponse.data.Circuits.length > 1) {
                    this.ordData = {};
                    this.formSubmitted = false;
                    this.circuits = saveResponse.data.Circuits;
                    this.ordData = saveResponse.data.Order;
                    this.dialogCircuit = true;
                } else {
                    this.$fun.alert("Guardado Correctamente", "success");
                    if (this.isTransport) {
                        this.$emit("orderSaved", { Order: saveResponse.data[0] });
                    }

                    this.$emit("close");
                    this.$emit("onCloseClear");
                    this.$emit("onClose");

                    if (this.typeOrder == 3) {
                        this.$emit("clearItemsCard");
                    } else if (this.typeOrder == 1) {
                        this.$emit("clearItemsCard");
                    }
                }

            } catch (error) {
                this.formSubmitted = false;
            }
        },
        filterAttributes(obj, attrs) {
            const filteredObj = {};
            attrs.forEach(attr => {
                if (obj.hasOwnProperty(attr)) {
                    filteredObj[attr] = obj[attr];
                }
            })
            return filteredObj;
        },
        findRepeatedObjects(items, attrs) {
            let verfifica = false;
            for (let i = 0; i < items.length; i++) {
                for (let j = i + 1; j < items.length; j++) {
                    const filteredObj1 = this.filterAttributes(items[i], attrs);
                    const filteredObj2 = this.filterAttributes(items[j], attrs);
                    const commontCount = this.countCommonAttributes(filteredObj1, filteredObj2, attrs);
                    if (commontCount >= 4) {
                        verfifica = true;
                    }
                }
            }
            return verfifica;
        },
        countCommonAttributes(obj1, obj2, attrs) {
            let count = 0;
            attrs.forEach(attr => {
                if (obj1[attr] === obj2[attr]) {
                    count++;
                }
            });
            return count;
        },
        async showPreviewDialog(file) {
            if (!file) return;

            this.currentFile = file;

            // Detectar tipo de archivo
            const fileType = this.detectFileType(file);
            this.previewType = fileType;

            // Excel
            if (fileType === 'excel') {
                this.previewDialog = true;
                await this.loadExcelFile(file);
                return;
            }

            // Word
            if (fileType === 'word') {
                this.previewDialog = true;
                await this.loadWordFile(file);
                return;
            }

            // Para imágenes y PDFs
            if (file instanceof File) {
                this.previewUrl = URL.createObjectURL(file);
            } else if (typeof file === 'string') {
                this.previewUrl = file;
            }

            this.previewDialog = true;
        },

        detectFileType(file) {
            let mimeType = '';
            let extension = '';

            if (file instanceof File) {
                mimeType = file.type;
                extension = file.name.split('.').pop().toLowerCase();
            } else if (typeof file === 'string') {
                extension = file.split('.').pop().toLowerCase();
            }

            // Imágenes
            if (mimeType.startsWith('image/') || ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
                return 'image';
            }

            // PDFs
            if (mimeType === 'application/pdf' || extension === 'pdf') {
                return 'pdf';
            }

            // Excel
            if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                mimeType === 'application/vnd.ms-excel' ||
                ['xlsx', 'xls'].includes(extension)) {
                return 'excel';
            }

            // Word
            if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                mimeType === 'application/msword' ||
                ['docx', 'doc'].includes(extension)) {
                return 'word';
            }

            return 'other';
        },

        async loadExcelFile(file) {
            try {
                let arrayBuffer;

                if (file instanceof File) {
                    arrayBuffer = await file.arrayBuffer();
                } else if (typeof file === 'string') {
                    const response = await fetch(file);
                    arrayBuffer = await response.arrayBuffer();
                }

                const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                this.excelSheets = workbook.SheetNames;
                this.loadSheetData(workbook, 0);

            } catch (error) {
                console.error('Error al cargar Excel:', error);
                alert('Error al cargar el archivo Excel');
                this.closePreview();
            }
        },

        loadSheetData(workbook, sheetIndex) {
            const sheetName = this.excelSheets[sheetIndex];
            const worksheet = workbook.Sheets[sheetName];

            this.excelData = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: '',
                raw: false
            });
        },

        async loadWordFile(file) {
            try {
                let arrayBuffer;

                // Si es archivo local
                if (file instanceof File) {
                    arrayBuffer = await file.arrayBuffer();
                }
                // Si es URL del servidor
                else if (typeof file === 'string') {
                    const response = await fetch(file);
                    arrayBuffer = await response.arrayBuffer();
                }

                // Convertir Word a HTML
                const result = await mammoth.convertToHtml(
                    { arrayBuffer: arrayBuffer },
                    {
                        styleMap: [
                            "p[style-name='Heading 1'] => h1:fresh",
                            "p[style-name='Heading 2'] => h2:fresh",
                            "p[style-name='Heading 3'] => h3:fresh",
                        ]
                    }
                );

                this.wordContent = result.value;

                // Mostrar warnings si hay
                if (result.messages.length > 0) {
                    console.log('Warnings de conversión:', result.messages);
                }

            } catch (error) {
                console.error('Error al cargar Word:', error);
                alert('Error al cargar el archivo Word');
                this.closePreview();
            }
        },

        closePreview() {
            // Liberar URL temporal si existe
            if (this.currentFile instanceof File && this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl);
            }

            this.previewDialog = false;
            this.previewUrl = null;
            this.previewType = null;
            this.currentFile = null;
            this.excelData = [];
            this.excelSheets = [];
            this.currentSheet = 0;
            this.wordContent = ''; // ← Limpiar contenido Word
        },

        async downloadFile(file) {
            if (!file) return;

            let fileUrl, fileName;

            // Si es un archivo nuevo (objeto File)
            if (file instanceof File) {
                fileUrl = URL.createObjectURL(file);
                fileName = file.name;
            }
            // Si es una URL del servidor (string)
            else if (typeof file === 'string') {
                fileUrl = file;
                // Extraer nombre del archivo de la URL
                fileName = file.split('/').pop() || 'archivo';
            }

            try {
                // Crear elemento <a> temporal para forzar descarga
                const link = document.createElement('a');
                link.href = fileUrl;
                link.download = fileName;
                link.target = '_blank';

                // Para URLs del servidor, puede necesitar fetch
                if (typeof file === 'string') {
                    // Fetch el archivo y crear blob
                    const response = await fetch(fileUrl);
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);

                    link.href = blobUrl;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Limpiar blob URL
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
                } else {
                    // Para archivos locales
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Limpiar URL temporal
                    setTimeout(() => URL.revokeObjectURL(fileUrl), 100);
                }
            } catch (error) {
                console.error('Error al descargar:', error);
                // Fallback: abrir en nueva pestaña
                window.open(fileUrl, '_blank');
            }
        },

        async loadSelected(selectedField, targetProperty) {
            try {
                const response = await _sSaleOrder.list_selected({ selected: selectedField }, this.$fun.getUserID());
                if (response.status === 200 && response.data) {
                    this[targetProperty] = response.data;
                }
            } catch (error) {
                console.error(`Error al cargar ${selectedField}:`, error);
            }
        },

        initializeOrderSaved() {
            _sOrderPurchase.byID({ OrdID: this.value }, this.$fun.getUserID()).then((r) => {
                console.log("r.dataaaaaaaaaaaaaaaaa", JSON.parse(JSON.stringify(r.data)));
                this.orderLocal = r.data;
                this.OrdStatusValue = this.orderLocal.OrdStatus;
                console.log("this.orderLocal", JSON.parse(JSON.stringify(this.orderLocal)));
                this.PytID = this.orderLocal.PytID;
                let sup = {
                    SupID: this.orderLocal.SupCode,
                    SupName: this.orderLocal.SupName,
                };
                this.dateOrder = this.orderLocal.OrdDate;

                if (this.orderLocal.TypeOrder == 3) {
                    this.headersSAP.splice(2, 0, {
                        text: "Cuenta Mayor",
                        value: "AcoName",
                        width: 220,
                        sortable: false,
                    });
                    this.headersSAP.splice(3, 0, {
                        text: "Cuenta Contable",
                        value: "AcoDescription",
                        width: 220,
                        sortable: false,
                    });
                    this.headersSAP.splice(4, 0, {
                        text: "Cant",
                        value: "DerQuantity",
                        sortable: false,
                    });
                    this.headersSAP.splice(4, 0, {
                        text: "Atendido",
                        value: "OddQuantity",
                        sortable: false,
                    });

                    this.isUpdateAccount = true;
                } else {
                    this.headersSAP.splice(
                        2,
                        0,
                        { text: "Cant", value: "DerQuantity", sortable: false },
                        { text: "Atendido", value: "OddQuantity", sortable: false },
                        { text: "Und", value: "UnitMeasurement", sortable: false }
                    );
                }
                this.Attach1 = { name: r.data.OrdAttach1 };
                this.Attach2 = { name: r.data.OrdAttach2 };
                this.Attach3 = { name: r.data.OrdAttach3 };
                this.Attach4 = { name: r.data.OrdAttach4 };
                this.Supplier = sup;
                console.log("this.Supplier", this.Supplier);
                this.OrdStatus = r.data.OrdStatus;
                this.itemsSAP = (r.data.Detail) ? r.data.Detail : [];
                console.log("this.itemsSAP", this.itemsSAP);
                this.configureHeadersSAP();
                this.calculateTotals(); // Recalcular totales al cargar
                this.loading = false;
                this.loadingCard = false;
                this.orderLocal.Transaction.OrdStatus = this.orderLocal.OrdStatus;
                this.transactionApproved = this.orderLocal.Transaction;
                if (this.orderLocal.Transaction != null)
                    if (this.orderLocal.Transaction.UsersApproved.length > 0) {
                        if (this.orderLocal.Transaction.UsersApproved.find((x) => x.UsrID == this.$fun.getUserID())) {
                            if (this.orderLocal.OrdStatus == 4) {
                                this.optionApproved = true;
                            } else this.optionApproved = false;
                        }
                    }
            });
        },
        configureHeadersSAP() {
            const isService = this.orderLocal.TypeOrder == 3 || this.typeOrder == 3;
            if (!isService) return;

            const isMaintenance = (this.itemsSAP && this.itemsSAP.some(x =>
                x && (x.AreIDReq == 24 || (x.AreNameReq && x.AreNameReq.toString().trim().toUpperCase() === 'MANTENIMIENTO'))
            )) || (this.orderLocal && (this.orderLocal.AreIDReq == 24 || (this.orderLocal.AreNameReq && this.orderLocal.AreNameReq.toString().trim().toUpperCase() === 'MANTENIMIENTO')));

            const sysIndex = this.headersSAP.findIndex(h => h.value === 'SysNameReq');

            if (isMaintenance) {
                if (sysIndex === -1) {
                    const areIndex = this.headersSAP.findIndex(h => h.value === 'AreNameReq');
                    if (areIndex !== -1) {
                        this.headersSAP.splice(areIndex + 1, 0,
                            { text: "Sistema", value: "SysNameReq", sortable: false, width: 180 },
                            { text: "Componente", value: "ComNameReq", sortable: false, width: 180 }
                        );
                    } else {
                        this.headersSAP.push(
                            { text: "Sistema", value: "SysNameReq", sortable: false, width: 180 },
                            { text: "Componente", value: "ComNameReq", sortable: false, width: 180 }
                        );
                    }
                }
            } else {
                if (sysIndex !== -1) {
                    this.headersSAP = this.headersSAP.filter(h => h.value !== 'SysNameReq' && h.value !== 'ComNameReq');
                }
            }
        },
    },
    beforeDestroy() {
        // Limpiar URLs temporales al destruir el componente
        if (this.previewUrl && this.currentFile instanceof File) {
            URL.revokeObjectURL(this.previewUrl);
        }
    },
    async created() {
        if (this.initialAttach1 instanceof File) {
            this.Attach1 = this.initialAttach1;
        }

        _sGenParam.search({ PrmName: "ShowOptionsSupply" }, this.$fun.getUserID()).then(resp => {
            this.ShowOptionsSupply = resp.data.PrmValue;
        });

        _sGenParam.search({ PrmName: "urlWhatsApp1" }, this.$fun.getUserID()).then(resp => {
            this.urlWhatsApp1 = resp.data.PrmValue;
        });

        _sGenParam.search({ PrmName: "urlWhatsApp2" }, this.$fun.getUserID()).then(resp => {
            this.urlWhatsApp2 = resp.data.PrmValue;
        });

        _sGenParam.search({ PrmName: "numberWhatsAppAPI" }, this.$fun.getUserID()).then(resp => {
            this.numberWhatsAppAPI = resp.data.PrmValue;
        });

        _sGenParam.search({ PrmName: "tokenWhatsAppAPI" }, this.$fun.getUserID()).then(resp => {
            this.tokenWhatsAppAPI = resp.data.PrmValue;
        });

        _sGenParam.search({ PrmName: "UseServiceLayer" }, this.$fun.getUserID(),).then(resp => {
            this.UseServiceLayer = resp.data.PrmValue;
        });

        this.loading = true;
        this.loadingCard = true;
        this.getGoodServiceList();
        if (this.orderLocal.OrdID == null) {
            this.orderLocal.ClassOperationPurchase = this.typeOrder == 1 ? 2 : 4;
        }
        this.orderLocal.ManagerPurchase = this.$fun.getUserSAPInfo().UssWorkerID;
        if (this.value != null) {
            console.log("this.value", this.value);
            this.initializeOrderSaved();
        } else {
            console.log("this.order en edicion", this.order);
            if (this.isStatusActive) {
                this.orderLocal.OrdStatus = 7;
            }
            this.orderLocal.TypeOrder = this.typeOrder;
            this.itemsSAP = this.order.detail;
            this.loading = false;
            this.loadingCard = false;
            if (this.itemsSAP)
                for (let i = 0; i < this.itemsSAP.length; i++)
                    this.itemsSAP[i].Line = i + 1;
            if (this.typeOrder == 3) {
                this.headersSAP.splice(2, 0, {
                    text: "Cuenta Mayor",
                    value: "AcoName",
                    width: 220,
                    sortable: false,
                });
                this.headersSAP.splice(3, 0, {
                    text: "Cuenta Contable",
                    value: "AcoDescription",
                    width: 220,
                    sortable: false,
                });
                this.headersSAP.splice(4, 0, {
                    text: "Cant",
                    value: "DerQuantity",
                    sortable: false,
                });
            }
            else if (this.typeOrder == 1)
                this.headersSAP.splice(
                    2,
                    0,
                    { text: "N° Articulo", value: "ArtCode", sortable: false },
                    { text: "Cant", value: "DerQuantity", sortable: false },
                    { text: "Atendido", value: "OddQuantity", sortable: false },
                    { text: "Und", value: "UnitMeasurement", sortable: false }
                );

            this.configureHeadersSAP();

            if (this.order.SupID) {
                this.Supplier = {
                    SupID: this.order.SupID,
                    SupName: this.order.SupName,
                    SupCode: this.order.SupID,
                };

                this.orderLocal.SupCode = this.order.SupID;
                this.orderLocal.SupName = this.order.SupName;
                this.orderLocal.ConID = this.order.ConID;
                this.orderLocal.TypeCurrency = this.order.TypeCurrency;
                this.orderLocal.OrdDocRate = this.order.OrdDocRate;
                this.orderLocal.OrdDiscountPercentage = this.order.OrdDiscountPercentage;
                this.orderLocal.OrdDocumentNumber = this.order.QuoteNumber;

                if (this.order.QuoteNumber) {
                    this.orderLocal.OrdObservation = (this.orderLocal.OrdObservation || "") + " Cotización: " + this.order.QuoteNumber;
                    this.orderLocal.QuoteNumber = this.order.QuoteNumber;
                }

                // Recalculate totals to apply discounts
                this.$nextTick(() => {
                    if (this.itemsSAP) {
                        this.itemsSAP.forEach(item => {
                            this.changeItem(item);
                        });
                    }
                });
            }
        }

        _sRequirement.ConceptService(this.$fun.getUserID()).then((r) => {
            this.itemsConcept = r.data;
            if (this.itemsConcept.length > 0)
                this.ConName = this.itemsConcept[0].ConName;
        });

        this.changeTotal();
    },
    watch: {
        itemsSAP: {
            handler() {
                this.configureHeadersSAP();
            },
            deep: true
        },
        currentSheet(newSheetIndex) {
            if (this.previewType === 'excel' && this.currentFile) {
                this.loadExcelFile(this.currentFile).then(() => {
                    if (this.excelSheets.length > 0) {
                        const arrayBuffer = this.currentFile instanceof File
                            ? this.currentFile.arrayBuffer()
                            : fetch(this.currentFile).then(r => r.arrayBuffer());

                        arrayBuffer.then(buffer => {
                            const workbook = XLSX.read(buffer, { type: 'array' });
                            this.loadSheetData(workbook, newSheetIndex);
                        });
                    }
                });
            }
        },
        ConName() {
            _sRequirement
                .AccountConceptService(this.ConName, this.$fun.getUserID()).then((ar) => {
                    this.itemsAccount = ar.data;
                    if (this.itemsAccount.length > 0) this.AcoID = this.itemsAccount[0];
                });
        },
        Supplier(val) {
            if (val && val.SupID) {
                this.SupID = val.SupID;
                this.orderLocal.SupCode = val.SupID;
                this.orderLocal.SupName = val.SupName;

                if (!this.value) {

                    if (val.PytID) {
                        this.PytID = val.PytID;
                    }
                }
            }
        },
    },

    mounted() {
        //  this.loadingCard = true;
    },
};
</script>

<style scoped>
/* Estilos Excel (mantener los existentes) */
.excel-preview {
    background-color: #f5f5f5;
}

.excel-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    background: white;
}

.excel-table td {
    border: 1px solid #e0e0e0;
    padding: 6px 10px;
    min-width: 80px;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.excel-table tr:first-child td {
    background-color: #1976d2;
    color: white;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 1;
}

.excel-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.excel-table tr:hover {
    background-color: #e3f2fd;
}

/* Estilos Word */
.word-preview {
    background-color: #f5f5f5;
    max-height: 600px;
    overflow-y: auto;
}

.word-content {
    background: white;
    max-width: 800px;
    margin: 0 auto;
    padding: 40px !important;
    min-height: 500px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* Estilos para el contenido HTML del Word */
.word-content>>>p {
    margin-bottom: 12px;
    line-height: 1.6;
    text-align: justify;
}

.word-content>>>h1 {
    font-size: 24px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 12px;
    color: #1976d2;
}

.word-content>>>h2 {
    font-size: 20px;
    font-weight: bold;
    margin-top: 16px;
    margin-bottom: 10px;
    color: #424242;
}

.word-content>>>h3 {
    font-size: 16px;
    font-weight: bold;
    margin-top: 12px;
    margin-bottom: 8px;
    color: #616161;
}

.word-content>>>ul,
.word-content>>>ol {
    margin-left: 20px;
    margin-bottom: 12px;
}

.word-content>>>li {
    margin-bottom: 6px;
    line-height: 1.6;
}

.word-content>>>strong {
    font-weight: bold;
}

.word-content>>>em {
    font-style: italic;
}

.word-content>>>table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
}

.word-content>>>table td,
.word-content>>>table th {
    border: 1px solid #ddd;
    padding: 8px;
}

.word-content>>>table th {
    background-color: #f5f5f5;
    font-weight: bold;
}

.word-content>>>img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 16px 0;
}

/* ══════════════════════════════════════════════════════════
   iOS-STYLE FUTURISTIC BOTTOM TAB PANEL
══════════════════════════════════════════════════════════ */

.ios-tab-panel {
    margin-top: 16px;
    border-radius: 20px;
    overflow: hidden;
    background: linear-gradient(135deg, #f8f9ff 0%, #eef0fb 100%);
    box-shadow:
        0 4px 24px rgba(108, 99, 255, 0.08),
        0 1px 4px rgba(0, 0, 0, 0.06);
    /* border: 1px solid rgba(108, 99, 255, 0.12); */
}

/* ── Tab Bar ─────────────────────────────────────────── */
.ios-tab-bar {
    display: flex;
    align-items: stretch;
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(108, 99, 255, 0.10);
    padding: 0 12px;
    gap: 4px;
    min-height: 52px;
}

/* ── Individual Tab Button ───────────────────────────── */
.ios-tab-btn {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 18px;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 14px 14px 0 0;
    transition: background 0.22s ease, color 0.22s ease;
    white-space: nowrap;
    outline: none;
}

.ios-tab-btn:hover {
    background: rgba(108, 99, 255, 0.07);
}

.ios-tab-btn.active {
    background: rgba(108, 99, 255, 0.10);
}

/* ── Tab Icon wrapper ─────────────────────────────────── */
.ios-tab-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.22s ease;
}

.ios-tab-btn.active .ios-tab-icon {
    transform: scale(1.15);
}

/* ── Tab Label ────────────────────────────────────────── */
.ios-tab-label {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: #04abc5;
    transition: color 0.22s ease;
    user-select: none;
}

.ios-tab-btn.active .ios-tab-label {
    color: #028a9f;
}

/* ── Active Underline Indicator ───────────────────────── */
.ios-tab-indicator {
    position: absolute;
    bottom: 0;
    left: 16px;
    right: 16px;
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: linear-gradient(90deg, #028a9f, #04abc5);
    animation: ios-indicator-in 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes ios-indicator-in {
    from {
        transform: scaleX(0);
        opacity: 0;
    }

    to {
        transform: scaleX(1);
        opacity: 1;
    }
}

.ios-tab-badge {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #fff;
    background: linear-gradient(135deg, #028a9f, #04abc5);
    border-radius: 20px;
    padding: 1px 7px;
    line-height: 1.6;
    box-shadow: 0 2px 6px rgba(170, 168, 202, 0.35);
}

.ios-tab-content {
    padding: 16px 16px 20px;
}

.ios-tab-pane {
    animation: ios-pane-enter 0.28s ease;
}

@keyframes ios-pane-enter {
    from {
        opacity: 0;
        transform: translateY(6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.ios-fade-enter-active,
.ios-fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.ios-fade-enter,
.ios-fade-leave-to {
    opacity: 0;
    transform: translateY(5px);
}


@media (max-width: 600px) {
    .ios-tab-btn {
        padding: 0 10px;
        flex-direction: column;
        gap: 2px;
        min-height: 56px;
        border-radius: 10px 10px 0 0;
    }

    .ios-tab-label {
        font-size: 10px;
    }

    .ios-tab-badge {
        font-size: 9px;
        padding: 1px 5px;
    }
}
</style>